import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";
import BackLink from "../Common/BackLink";
import Button from "../Common/Button";

const OrderSuccessModal = ({ isOpen, onClose, onViewOrder }) => {
    const { t } = useTranslation();
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-8">
            <div className="relative w-full max-w-md overflow-hidden rounded-2xl bg-white shadow-[0_20px_60px_rgba(0,0,0,0.25)] md:max-w-4xl">
                <button
                    type="button"
                    onClick={onClose}
                    className="absolute right-4 top-4 z-10 flex h-10 w-10 items-center justify-center rounded-full bg-white/90 shadow focus:outline-none"
                >
                    <X className="h-6 w-6 text-primary" />
                </button>
                <div className="grid grid-cols-1 md:grid-cols-2">
                    <div className="p-6 text-center sm:p-8 md:p-12">
                        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary">
                            <Check className="h-6 w-6 text-white" />
                        </div>
                        <h2 className="mt-6 text-lg font-semibold text-slate-900">{t("PRODUCT_COLLECTIONS_ORDER_SUCCESS_TITLE")}</h2>
                        <p className="mt-2 text-sm text-slate-500">
                            {t("PRODUCT_COLLECTIONS_ORDER_SUCCESS_SUBTITLE")}
                        </p>
                        <div className="mt-6 space-y-3">
                            <BackLink
                                label={t("COMMON_BACK_TO_HOME")}
                                onClick={onClose}
                                className="inline-flex w-full items-center justify-center gap-2 text-xs font-semibold text-slate-500 underline underline-offset-4"
                            />
                            <Button
                                type="button"
                                onClick={onViewOrder}
                                variant="secondary"
                                className="w-full"
                            >
                                {t("PRODUCT_COLLECTIONS_VIEW_ORDER")}
                            </Button>
                        </div>
                    </div>
                    <div className="relative order-first h-48 w-full overflow-hidden sm:h-56 md:order-none md:h-auto">
                        <img
                            src="/assets/images/common/complete-order.png"
                            alt=""
                            className="h-full w-full object-cover"
                        />
                        <div className="absolute inset-0 bg-white/10" />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderSuccessModal;
